
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5444e201&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ModalFactory.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalFactory.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5444e201!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalFactory.vue"),
  /* scopeId */
  "data-v-5444e201",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/modal/ModalFactory.vue
// module id = 245
// module chunks = 2